import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import * as actions from './actions';
import { SharePointDetails } from './model';
import { initialStatus, Status } from 'projects/angular-clarity/src/app/stores/status.interface';

export const featureKey = 'graphSpoSharePointDetails';

export interface State extends EntityState<SharePointDetails>, Status {}

export const adapter: EntityAdapter<SharePointDetails> = createEntityAdapter<SharePointDetails>({
    // Keyed by siteId, not siteUrl: Microsoft conceals site URLs in usage reports unless the
    // tenant opts out, and a null siteUrl collapsed every site into a single entity.
    selectId: (site) => site.siteId,
});

export const initialState: State = adapter.getInitialState({
    ...initialStatus,
});

export const reducer = createReducer(
    initialState,
    on(actions.loadSPOSiteUsageSuccess, (state, action) =>
        adapter.setAll(action.data, { ...state, loaded: true, error: null }),
    ),
    on(actions.loadSPOSiteUsageFailure, (state, { error }) => ({ ...state, loaded: true, error })),
);

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
